import Web3 from 'web3';
import configJson from 'config/config.json';
import { getStoredChainId, getStoredNetworkInfo, web3WalletConnector } from '../../services/walletService';
import networksConf from '../../config/networks.json';
import { setupWeb3 } from '../../services/web3Service';
import {
  CONNECT_WALLET_START,
  CONNECT_WALLET_END,
  CONNECT_WALLET_PROVIDER,
  CONNECT_WALLET_PROVIDER_SUCCESS,
  CONNECT_WALLET_PROVIDER_FAILURE,
  CLEAR_ACCOUNT,
  SET_ACCOUNT,
} from '../actionTypes/walletActionTypes';
import { LS_ACCOUNT } from '../../constants/general';
import { closeModal } from './modalActions';
import { wait } from '../../services/utilsService';
import { eventSetup } from '../../utils/events';
import { walletEvents } from '../../constants/wallet';

const postLogin = () => () => {};

const { networks = [] } = networksConf;
const networkWithWeb3Instances = networks.map((network) => ({
  ...network,
  web3Instance: new Web3(network.rpcUrl),
}));

export const findNetworkById = (id) => {
  const network = networkWithWeb3Instances.find((network) => +network.id === id);
  return network;
};

export const onWalletConnectRequestAction = (accountType) => (dispatch) => {
  dispatch({ type: CONNECT_WALLET_START, payload: accountType });
  dispatch({ type: CONNECT_WALLET_PROVIDER });
};

export const directConnect = (account) => (dispatch) => {
  dispatch({
    type: SET_ACCOUNT,
    payload: account,
  });
};

export const onWalletConnectSuccessAction =
  ({ provider, account, connectionType, ...additions }) =>
  async (dispatch, getState) => {
    setupWeb3(provider);
    localStorage.setItem(LS_ACCOUNT, connectionType);
    dispatch({
      type: CONNECT_WALLET_PROVIDER_SUCCESS,
      payload: { account, accountType: connectionType, network: configJson.network, additions },
    });

    if (getState().wallet.account) await dispatch(postLogin());

    dispatch({ type: CONNECT_WALLET_END });
  };

export const onWalletConnectErrorAction = (err) => (dispatch) => {
  dispatch({ type: CONNECT_WALLET_PROVIDER_FAILURE, payload: err.message });
  setupWeb3();
};

export const onWalletDisconnectAction = () => (dispatch) => {
  dispatch({ type: CLEAR_ACCOUNT });
  localStorage.removeItem(LS_ACCOUNT);
};

/**
 * Tries not silent login for the selected account type
 *
 * @param accountType {String}
 *
 * @return {Function}
 */
export const normalLogin = (accountType, passedNetworkInfo) => async (dispatch, getState) => {
  dispatch({ type: CONNECT_WALLET_START, payload: accountType });
  dispatch({ type: CONNECT_WALLET_PROVIDER });
  const storedNetworkInfo = passedNetworkInfo || findNetworkById(window.chainId);
  const { additions = {} } = getState().wallet;
  try {
    if (!web3WalletConnector.mounted) {
      await wait(500);
    }
    const { provider, account, ...walletAdditions } = await web3WalletConnector.connect({
      rpcUrl: storedNetworkInfo?.rpcUrl || configJson.rpcUrl,
      networkId: storedNetworkInfo?.networkId || configJson.network,
      connectionType: accountType,
      ...additions,
    });
    setupWeb3(provider);
    localStorage.setItem(LS_ACCOUNT, web3WalletConnector.connectionType);

    dispatch({
      type: CONNECT_WALLET_PROVIDER_SUCCESS,
      payload: {
        account,
        accountType: web3WalletConnector.connectionType,
        network: window.chainId || configJson.network,
        additions: walletAdditions,
      },
    });
  } catch (err) {
    dispatch({ type: CONNECT_WALLET_PROVIDER_FAILURE, payload: err.message });
    setupWeb3();
  }

  // dispatch(setLsValuesToReducer());
  if (getState().wallet.account) await dispatch(postLogin());

  dispatch({ type: CONNECT_WALLET_END });
};

/**
 * If the user has already once successfully added an account this will
 * try a silent login for that account type.
 *
 * @return {Function}
 */
export const silentLogin = () => async (dispatch, getState) => {
  // should be done with stored network id
  const { accountType, connectingWallet, account } = getState().wallet;
  console.log('SILENT_LOGIN', accountType);
  if (!accountType || connectingWallet || account) return;

  dispatch({ type: CONNECT_WALLET_START, payload: accountType });
  const storedNetwork = getStoredNetworkInfo();
  try {
    if (accountType) {
      await dispatch(normalLogin(accountType, storedNetwork));
    }
  } catch (err) {
    setupWeb3();
  }

  if (getState().wallet.account) await dispatch(postLogin());

  // dispatch(setLsValuesToReducer());
  dispatch({ type: CONNECT_WALLET_END });
};

export const logOut = () => async (dispatch, getState) => {
  const { modalType } = getState().modal;
  dispatch({ type: CLEAR_ACCOUNT });
  if (modalType !== '') {
    dispatch(closeModal());
  }
  dispatch(normalLogin());
  localStorage.removeItem(LS_ACCOUNT);
};

export const switchNetwork = (networkId) => async (dispatch, getState) => {
  const { accountType, additions = {} } = getState().wallet;
  const network = findNetworkById(networkId);
  await web3WalletConnector.connect({
    rpcUrl: network?.rpcUrl,
    networkId: network?.networkId,
    connectionType: accountType,
    ...additions,
  });
  eventSetup.trigger(walletEvents.NETWORK_CHANGED);
};
setTimeout(() => {
  eventSetup.trigger('test');
}, 3000);
